import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogTitle } from '@radix-ui/react-dialog';

import { ChevronLeftIcon } from '@/assets/icons';
import { Button, IconBox } from '@/components/atoms';
import { IconName } from '@/components/atoms/Icon/types';
import { CATEGORY_POPUP_TEST_IDS } from '@/constants/data-testids';

import { SetCategoryPopupData, SetCategoryPopupStep } from '../CategoryPopup';
import { CATEGORY_ICONS } from '../constants';

type IconPickerCategoryPopupProps = {
  setCategoryData: SetCategoryPopupData;
  setStep: SetCategoryPopupStep;
};

export const IconPickerCategoryPopup: FC<IconPickerCategoryPopupProps> = ({
  setCategoryData,
  setStep,
}) => {
  const onSelectIcon = (name: IconName) => {
    setCategoryData(prev => ({
      ...prev,
      icon: name,
    }));

    setStep('step1');
  };
  const { t } = useTranslation('components');

  return (
    <div data-testid={CATEGORY_POPUP_TEST_IDS.STEP1_ICON} className="relative">
      <div className="mb-4">
        <Button
          className="mb-2"
          size="xxs"
          variant="teritary"
          leftIcon={<ChevronLeftIcon width={20} height={20} />}
          onClick={() => setStep('step1')}
        >
          {t('iconPickerCategoryPopup.buttons.backButton')}
        </Button>
        <DialogTitle className="text-body-20-semibold text-custom-warm-grey-700">
          {t('iconPickerCategoryPopup.buttons.choseIconButton')}
        </DialogTitle>
      </div>

      <div className="flex flex-col gap-5 max-h-[660px] overflow-y-auto">
        {CATEGORY_ICONS.map(({ categoryName, icons }) => (
          <div key={categoryName}>
            <h4 className="text-body-14-semibold text-custom-warm-grey-700 mb-3">
              {t(categoryName)}
            </h4>
            <div className="flex items-center gap-4 flex-wrap">
              {icons.map(({ icon, name }) => (
                <IconBox
                  key={name}
                  icon={icon}
                  size="large"
                  className="cursor-pointer"
                  iconClassName="text-custom-cyan-500"
                  onClick={() => onSelectIcon(name)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 w-full h-5 bg-gradient-to-b from-white/0 to-custom-warm-grey-25" />
    </div>
  );
};
